const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
const LAST_BOOKABLE_START_TIMES = {
	"in-person": "17:00",
	virtual: "18:00",
};

export function isAppointmentStartTimeAllowed(time, mode) {
	const lastStartTime = LAST_BOOKABLE_START_TIMES[mode];
	if (!lastStartTime) return true;
	if (!TIME_PATTERN.test(time)) return false;
	return time <= lastStartTime;
}

export function filterAppointmentTimes(times, mode) {
	const availableTimes = mode === "virtual" && times.includes("17:00") && !times.includes("18:00")
		? [...times, "18:00"]
		: times;
	return availableTimes.filter((time) => isAppointmentStartTimeAllowed(time, mode));
}

export function isTimeBlocked(date, time, blockedSlots = [], blockedTimeRanges = []) {
	if (blockedSlots.includes(`${date}_${time}`)) return true;

	return blockedTimeRanges.some((range) => (
		range
		&& range.date === date
		&& TIME_PATTERN.test(range.startTime)
		&& TIME_PATTERN.test(range.endTime)
		&& range.startTime < range.endTime
		&& time >= range.startTime
		&& time < range.endTime
	));
}
